/**
 * Narrowing a list of named things as somebody types.
 *
 * Every typed word has to appear somewhere in the label, in any order — so "align left" and
 * "left align" both find the same command, and "wall" finds "Draw wall" without the admin
 * having to know the command starts with "Draw". Deliberately not fuzzy: a palette that
 * matches loosely puts a plausible wrong answer under the Enter key, and these commands
 * delete things.
 */
export const matchesQuery = (label: string, query: string): boolean => {
  const haystack = label.toLowerCase();

  return query
    .toLowerCase()
    .split(/\s+/)
    .filter((token) => token.length > 0)
    .every((token) => haystack.includes(token));
};

/** Keeps the items whose label matches, in the order they were given. */
export const filterByLabel = <T>(
  items: readonly T[],
  query: string,
  labelOf: (item: T) => string,
): T[] => {
  const needle = query.trim();

  if (needle.length === 0) {
    return [...items];
  }

  return items.filter((item) => matchesQuery(labelOf(item), needle));
};
